// extracted by mini-css-extract-plugin
export default {"input":"GifSearchInput-input-b55fe9a363fc0333ebb12412e79a0a74","searchButton":"GifSearchInput-searchButton-327b3991e7bea5f31723821363fac44d"};